import { useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import api from '../../../api';
import { useDispatch } from 'react-redux';
import { loadingStartAction } from 'src/redux/actions/loadingActions';

// components

// ----------------------------------------------------------------------

export default function GameRatesForm({ handleClose, selectedGame }) {
  // States for input fields
  const [bidPoints, setBidPoints] = useState(selectedGame?.bid_points || '');
  const [winningPoints, setWinningPoints] = useState(selectedGame?.winning_points || '');
  const [winningbyX, setWinningbyX] = useState(selectedGame?.winning_by_x || '');
  const [gameTypeID, setGameTypeID] = useState(selectedGame?.game_type_id || '');
  const [gameTypeData, setGameTypeData] = useState([]);

  const dispatch = useDispatch()

  const getAllGamesTypes = async () => {
    const response = await api.get('/game-types');
    setGameTypeData(response.data.results);
  };

  useEffect(() => {
    getAllGamesTypes();
  }, []);

  const handleGameCreate = async () => {
    const reqBody = {
      game_type_id: gameTypeID,
      bid_points: bidPoints,
      winning_points: winningPoints,
      winning_by_x: winningbyX,
      is_active: true,
    };

    handleClose();

    dispatch(loadingStartAction());
    if (selectedGame) {
      await api.put(`/game-rates/${selectedGame._id}`, reqBody);
    } else {
      await api.post('/game-rates', reqBody);
    }

    window.location.reload()
  };

  return (
    <>
      <Stack spacing={3} my={2}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Game Type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={gameTypeID}
            label="Select Game Type"
            onChange={(e) => setGameTypeID(e.target.value)}
          >
            {gameTypeData?.map((item) => {
              return (
                <MenuItem key={item._id} value={item._id}>
                  {item.game_type_name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <TextField
          name="bid_points"
          label="Bid Points"
          value={bidPoints}
          onChange={(e) => setBidPoints(e.target.value)}
        />
        <TextField
          name="winning_points"
          label="Winning Points"
          value={winningPoints}
          onChange={(e) => setWinningPoints(e.target.value)}
        />
        <TextField
          name="winning_by_x"
          label="Winning By - X"
          value={winningbyX}
          onChange={(e) => setWinningbyX(e.target.value)}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        {/* <Checkbox
          name="remember"
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
          label="Remember me"
        /> */}
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleGameCreate}>
        {selectedGame ? 'Update' : 'Create New'}
      </LoadingButton>
    </>
  );
}
